import * as PIXI from 'pixi.js';
import { Entity } from '../core/EntityManager';
import type { LootType } from '@hamsters/game-config';
import { getSprite } from '../content/SpriteCache';

export class Coin extends Entity {
  private coinSprite: PIXI.Sprite | null = null;
  private value: number;
  private lootType: LootType;
  private bobOffset = 0;
  private baseY = 0;

  constructor(type: LootType, value: number) {
    super();
    this.lootType = type;
    this.value = value;
    this.radius = 12;

    const texture = getSprite('coin');
    if (texture) {
      this.coinSprite = new PIXI.Sprite(texture);
      this.coinSprite.anchor.set(0.5);
      this.coinSprite.width = this.radius * 2;
      this.coinSprite.height = this.radius * 2;
      this.sprite.addChild(this.coinSprite);
    } else {
      this.drawFallback();
    }
  }

  private drawFallback(): void {
    const graphics = new PIXI.Graphics();
    graphics.circle(0, 0, 10);
    graphics.fill(0xffd700);
    graphics.circle(0, 0, 6);
    graphics.fill(0xffeb3b);
    this.sprite.addChild(graphics);
  }

  update(dt: number, _tick: number): void {
    this.bobOffset += dt * 3;
    this.sprite.y = this.baseY + Math.sin(this.bobOffset) * 3;
  }

  setValue(value: number): void {
    this.value = value;
  }

  getValue(): number {
    return this.value;
  }

  getType(): LootType {
    return this.lootType;
  }

  collect(): void {
    this.active = false;
    this.sprite.visible = false;
  }

  setBaseY(y: number): void {
    this.baseY = y;
  }
}
